import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export interface MrrSummary {
  current_mrr: number;
  previous_mrr: number;
  delta_pct: number | null;
  active_tenants: number;
  trial_tenants: number;
  delinquent_tenants: number;
  prospect_tenants: number;
  total_members: number;
}

export function useMrrSummary() {
  const [data, setData] = useState<MrrSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      const { data: result, error: err } = await supabase.functions.invoke<MrrSummary>("platform-mrr-summary");
      if (cancelled) return;
      if (err) {
        setError(err.message);
      } else {
        setData(result ?? null);
      }
      setLoading(false);
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return { data, loading, error };
}
